module.exports = __webpack_public_path__ + "img/2.e14b23a3.png";